import { useState } from 'react';
// API
import Api from '../../API';

export const useDeleteAccountLogin = () => {
  const [loading, setLoading] = useState(false);
  const [responseError, setResponseError] = useState('');

  const login = async (email, password, userEmail) => {
    setLoading(true);
    setResponseError('');

    return new Promise(async (resolve, reject) => {
      try {
        // check if provided email = current user email
        if (email !== userEmail) {
          setResponseError('Email provided is not your user email !');
          setLoading(false);

          resolve(responseError);
          return;
        }

        const response = await Api.login(email, password);
        setLoading(false);

        if (response.error) {
          setResponseError(response.error);
        }
        resolve(response.error);
      } catch (error) {
        console.log(error);
      }
    });
  };

  return { loading, responseError, login };
};
